import { z } from 'zod'

export const bigintTextSchema = z.string().regex(/^\d+$/).transform(BigInt)

export const addressPrimitiveSchema = z
  .string()
  .regex(/^[1-9A-HJ-NP-Za-km-z]{32,44}$/)
  .transform((v) => v)
